import { MutableRefObject, useRef } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledButton,
  StyledDeleteIcon,
  StyledDocumentUploadIcon,
  StyledInnerWrapper,
  StyledInput,
  StyledNav,
  StyledTitle,
  StyledWrapper,
} from './FileInput.styles';
import { FileInputProps } from './FileInput.types';

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = error => reject(error);
  });
};

export const FileInput = ({ file, onChange }: FileInputProps): JSX.Element => {
  const { t } = useTranslation('help');
  const fileInput = useRef<HTMLInputElement | null>(null);
  const deleteButtonRef = useRef(
    null,
  ) as MutableRefObject<HTMLButtonElement | null>;

  const handleDeleteButtonClick = async () => {
    onChange(undefined);
    if (fileInput.current) fileInput.current.value = '';
  };

  const handleUploadButtonClick = () => {
    fileInput?.current?.click();
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange((e.target.files as FileList)[0]);
  };

  const isUploaded = file !== undefined;

  return (
    <>
      <StyledWrapper>
        <StyledInnerWrapper>
          <StyledTitle noFile={!file}>
            {file ? file.name : t('noFileChoosen')}
          </StyledTitle>
          <StyledNav>
            {isUploaded ? (
              <StyledButton
                onClick={handleDeleteButtonClick}
                ref={deleteButtonRef}
                type="button"
              >
                <StyledDeleteIcon />
              </StyledButton>
            ) : (
              <StyledButton type="button" onClick={handleUploadButtonClick}>
                <StyledDocumentUploadIcon />
              </StyledButton>
            )}
          </StyledNav>
          <StyledInput
            accept="image/jpeg, image/png, application/pdf"
            ref={fileInput}
            type="file"
            onChange={handleInputChange}
          />
        </StyledInnerWrapper>
      </StyledWrapper>
    </>
  );
};
